import React from 'react';
import {connect} from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  withStyles} from '@material-ui/core';
import { Form } from 'react-final-form'
import { Field } from 'react-final-form-html5-validation';

import {validateSepa, savePaymentMethod, toggleNewSepaWindow} from "../../actions/PaymentActions";

import {jump, inputUppercase} from "../utils/FormUtils"

import styles from "./customMaterialUIStyle"

@connect(store => {
	return {
    messages:store.messages.messages,
    payment: store.payment
}})

class SepaPaymentDialog extends React.Component {

  componentDidUpdate(){
    const {payment = {}, dispatch} = this.props;
    const {SEPA} = payment;
    const {status = "FAIL"} = SEPA;
    if (status === "SUCCESS") {
      dispatch(savePaymentMethod());
    }
  }

  closeSepaPaymentDialog = () => {
    const { dispatch } = this.props;
    dispatch(toggleNewSepaWindow(false))
  }

  validatePayment = (form) => {
    const { dispatch } = this.props;
    dispatch(validateSepa(form));
  }

  render() {
    const {messages, payment: {SEPA = {}}} = this.props;
    const {status: SepaStatus = "", error: SepaError = "" } = SEPA;

    return (
      <Dialog
        open={true}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth='md'
      >
        <DialogTitle id="form-dialog-title"></DialogTitle>
        <DialogContent>
          <Form onSubmit={this.validatePayment} initialValues={{}}
              render={({handleSubmit, invalid, submitting}) => (
                <form onSubmit={handleSubmit} className="content">
                  <Grid container>
                    <Grid item md>
                      {SepaStatus === "FAIL" &&
                        <h2 className="error-color text-center">{SepaError}</h2>
                      }
                      <fieldset>
                        <legend className="grid-subtitle">
                          {messages["common.block.title.sepa"]}
                        </legend>
                        <Grid container className="middle-xs">
                          <Grid item xs={1} className="text-right form-label">
                            <label>{messages["common.label.iban"]}</label>
                          </Grid>
                          <Grid item xs>
                            <Field className="iban form-input" name="iban1" component="input"
                              pattern="[A-Z]{2}[0-9]{2}"
                              title="iban1"
                              maxLength="4" place="0" onInput={event=>jump(event, 4)} required/>
                            <Field className="iban form-input" name="iban2" component="input"
                              pattern="[A-Z0-9]{4}" title="iban2"
                              maxLength="4"
                              place="1" onInput={event=>jump(event, 4)} required/>
                            <Field className="iban form-input" name="iban3" component="input"
                              pattern="[A-Z0-9]{4}" title="iban3"
                              maxLength="4"
                              onInput={event=>jump(event, 4)} required/>
                            <Field className="iban form-input" name="iban4" component="input"
                              pattern="[A-Z0-9]{4}" title="iban4"
                              maxLength="4" onInput={event=>jump(event, 4)} required/>
                            <Field className="iban form-input" name="iban5" component="input"
                              pattern="[A-Z0-9]{4}" title="iban5"
                              maxLength="4" onInput={event=>jump(event, 4)} required/>
                            <Field className="iban form-input" name="iban6" component="input"
                              pattern="[A-Z0-9]{4}" title="iban6"
                              maxLength="4"
                              onInput={event=>jump(event, 4)} required/>
                            {/* <Field className="iban form-input" name="iban7" component="input"
                              pattern="[A-Z0-9]{3}" title="iban7"
                              maxLength="3"
                              onInput={event=>jump(event, 3)} required/> */}
                          </Grid>
                        </Grid>
                        {/* <Grid container className="middle-xs">
                          <Grid item xs={1} className="text-right form-label">
                            <label>{messages["common.label.bic"]}</label>
                          </Grid>
                          <Grid item xs>
                            <Field className="form-input" name="bic" component="input"
                              pattern="[a-zA-Z]{6}[0-9A-Z]{2}[0-9A-Z]{3}" title="Code BIC"
                              maxLength="11"
                              onInput={event=>inputUppercase(event)} required/>
                          </Grid>
                        </Grid> */}
                        <Grid container start="xs">
                        <Grid item xs className="text-right">
                          <Button 
                            className={`btn-small btn-theme-standard btn-secondary`} 
                            variant="contained"
                            onClick={this.closeSepaPaymentDialog}> 
                            {messages['common.button.cancel']}
                          </Button>								  
                          <Button 
                            className={`btn-small btn-theme-default btn-primary ${invalid || submitting ? "disabled-input" : ""}`}
                            type="submit" 
                            disabled={invalid || submitting}
                            variant="contained">
                              {messages['common.button.validate']}
                          </Button>
                        </Grid>
                      </Grid>
                      </fieldset>
                    </Grid>
                  </Grid>
                </form>
              )}
          />
        </DialogContent>
      </Dialog>
      );
  }
}

export default withStyles(styles)(SepaPaymentDialog);


// WEBPACK FOOTER //
// ./src/opencell/pages/client/SepaPaymentDialog.jsx